import { supabase } from './supabase';
import { ErrorDeApi } from './error-api';

export async function generarCodigoVinculacion(negocioId: string): Promise<string> {
  const { data, error, status } = await supabase.rpc('generar_codigo_vinculacion', { p_negocio: negocioId });
  if (error) throw new ErrorDeApi(error, status);
  return data as string;
}

export interface Semaforo {
  estado: 'verde' | 'amarillo' | 'rojo' | 'sin_uvt';
  ingresosAnio: number;
  umbralCop: number | null;
}

export async function obtenerSemaforo(negocioId: string): Promise<Semaforo | null> {
  const { data, error } = await supabase
    .from('v_semaforo')
    .select('estado, ingresos_anio, umbral_cop')
    .eq('negocio_id', negocioId)
    .maybeSingle();
  if (error || !data) return null;
  return {
    estado: data.estado,
    ingresosAnio: Number(data.ingresos_anio),
    umbralCop: data.umbral_cop === null ? null : Number(data.umbral_cop),
  };
}

export async function botVinculado(negocioId: string): Promise<boolean> {
  const { data } = await supabase
    .from('ajustes_negocio')
    .select('ajuste_clave')
    .eq('negocio_id', negocioId)
    .eq('ajuste_clave', 'telegram_chat_id')
    .maybeSingle();
  return !!data;
}
